// Načítání virtuální prohlídky a videoprohlídky
document.addEventListener("DOMContentLoaded", function() {
    var div, n, v = document.querySelectorAll(".view-player");
    if (v.length > 0) {
        v.forEach(function (e) {
            div = document.createElement("div");
            div.classList.add('fakePlayer');
            div.setAttribute("data-id", e.dataset.id);
            div.setAttribute("data-title", e.dataset.title);
            div.setAttribute("data-image", e.dataset.image);
            div.innerHTML = labnolThumb(e.dataset.id, e.dataset.image);
            div.onclick = labnolVideo;
            e.appendChild(div);
        });
    }
});

function labnolThumb(id, img) {
    var thumb= '<img src="'+ img +'">';
    var play =
            '<div class="play">' +
            '<svg width="150" height="150" viewBox="0 0 150 150" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M75 150c-41.25 0-75-33.75-75-75S33.75 0 75 0s75 33.75 75 75-33.75 75-75 75Zm0-132.692c-31.73 0-57.692 25.961-57.692 57.692S43.269 132.692 75 132.692 132.692 106.731 132.692 75c0-31.73-25.961-57.692-57.692-57.692Z" fill="#FFFFFF" fill-opacity=".5"/><path d="M100.962 70.096c3.75 2.308 3.75 7.789 0 10.096l-34.616 19.904c-3.75 2.308-8.654-.577-8.654-4.904V55.096c0-4.327 4.904-7.211 8.654-4.903l34.616 19.903Z" fill="currentColor"/></svg>' +
            '</div>';
    return thumb.replace("ID", id) + play;
}

function labnolVideo() {
    var video = document.createElement("video");
    video.setAttribute("src", this.dataset.id);
    video.setAttribute("controls", "true");
    video.setAttribute("autoplay", "true");
    this.parentNode.replaceChild(video, this);
}